module.exports = {
    FOXES_GIG_FOURTH_PACKAGE: 2520,
    OWLS_FIVERR_CHOICE_EXPANSION: 2587,
    CHAM_CAROUSEL_OBSERVER_B: 2611,
    QUAL_REVIEWS_INDUSTRIES: 2967,
    FOXES_CREATE_BRIEF: 3021,
    QUAL_REVIEWS_SORT_BY_COUNTRY: 3023,
    QUAL_REVIEWS_SORT_BY_COUNTRY_AA_TEST: 3033,
    QUAL_REVIEWS_LOYALTY: 3068,
    QUAL_REVIEWS_MOBILE_WEB: 3069,
    LIONS_GIG_CARD_FORMATTING: 3110,
    LIONS_STICKY_MT: 3081,
    FOXES_STICKY_SIDEBAR_C: 3106,
    QUAL_REVIEWS_SNIPPET_ALGO: 3112,
    FOXES_GIG_PAGE_CONTACT_SELLER_OPTIONS: 3114,
    GIG_PAGE_V5_EXPERIMENT: 3119
};
